const OPTIONS = [
  { id: "by_departure", name: "Por Salidas" },
  { id: "by_arrival", name: "Por Llegadas" },
];

function layout() {
  const ctxView = {
    model: "hotel.rooms_occupancy",
    reportName: "hotel.rooms_occupancy.report",
    description: "Estado de Ocupación de Habitaciones",
    fields: {
      operation_center: {
        type: "many2one",
        model: "company.operation_center",
        required: true,
      },
      date: {
        type: "date",
        required: true,
      },
      filter: {
        type: "selection",
        required: true,
        options: OPTIONS,
      },
      only_main_guest: {
        type: "boolean",
        translate: true,
      },
    },
    list: [],
    form: [
      { name: "operation_center" },
      { name: "date" },
      { name: "filter" },
      { name: "only_main_guest" },
    ],
  };

  return ctxView;
}

export { layout };
